import { ITextMessageSource } from "atlas-shared";

export enum TextMessageSourceActions {
  SET_STATE = "TEXT_MESSAGE_SOURCE_SET_STATE",
  ADD_STATE = "TEXT_MESSAGE_SOURCE_ADD_STATE",
  REMOVE_STATE = "TEXT_MESSAGE_SOURCE_REMOVE_STATE",
  GET_STATE = "TEXT_MESSAGE_SOURCE_GET_STATE",
  UPDATE_STATE = "TEXT_MESSAGE_SOURCE_UPDATE_STATE",
  LOADING = "TEXT_MESSAGE_SOURCE_LOADING",
}

export interface TextMessageSourceLoading {
  type: TextMessageSourceActions.LOADING;
}

export interface TextMessageSourceSetAction {
  type: TextMessageSourceActions.SET_STATE;
  payload: Array<ITextMessageSource>;
}

export interface TextMessageSourceUpdateAction {
  type: TextMessageSourceActions.UPDATE_STATE;
  payload: ITextMessageSource;
}

export interface TextMessageSourceAddAction {
  type: TextMessageSourceActions.ADD_STATE;
  payload: ITextMessageSource;
}

export interface TextMessageSourceRemoveAction {
  type: TextMessageSourceActions.REMOVE_STATE;
  payload: ITextMessageSource["id"];
}

export interface ITextMessageSourceStore {
  loaded: boolean;
  loading: boolean;
  text_message_sources: Array<ITextMessageSource>;
  dict: Record<NonNullable<ITextMessageSource["id"]>, ITextMessageSource>;
}

export type TTextMessageSourceActionTypes =
  | TextMessageSourceSetAction
  | TextMessageSourceUpdateAction
  | TextMessageSourceAddAction
  | TextMessageSourceRemoveAction
  | TextMessageSourceLoading;
